import { render, staticRenderFns } from "./CompleteChangeEmail.vue?vue&type=template&id=186ad68a"
import script from "./CompleteChangeEmail.vue?vue&type=script&lang=js"
export * from "./CompleteChangeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports